import React from 'react';

const Plus = () => (
  <svg width="22" height="22" viewBox="0 0 22 22">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.5 12.5H12.5V21.5H9.5V12.5H0.5V9.5H9.5V0.5H12.5V9.5H21.5V12.5Z"
      fill="#FF6600"
    />
  </svg>
);

export default Plus;
